export default {"src":"/_next/static/media/ico_arrow_right.b2d6b97d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};